"use client";

// components/GoogleAnalyticsTracker.tsx
// Drop this anywhere inside <body> in layout.tsx.
// It fires a page_view event on every App Router navigation.

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

function initGtag(gaId: string) {
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", gaId, { send_page_view: false });
}

export default function GoogleAnalyticsTracker({ gaId }: { gaId: string }) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    // Initialise gtag on first mount (the <script> tag in layout loads the lib)
    if (typeof window !== "undefined" && !window.gtag) {
      initGtag(gaId);
    }
  }, [gaId]);

  useEffect(() => {
    if (!window.gtag) return;
    const url = pathname + (searchParams.toString() ? `?${searchParams}` : "");
    window.gtag("event", "page_view", {
      page_path: url,
    });
  }, [pathname, searchParams]);

  return null;
}